
import { Component, Vue, Watch } from 'vue-property-decorator'
const de_circle_1 = require('./../../../assets/imgs/de_circle_1.png'),
  de_circle_2 = require('./../../../assets/imgs/de_circle_2.png'),
  de_circle_3 = require('./../../../assets/imgs/de_circle_3.png'),
  de_circle_4 = require('./../../../assets/imgs/de_circle_4.png'),
  de_icon_1 = require('./../../../assets/imgs/de_icon_1.png'),
  de_icon_2 = require('./../../../assets/imgs/de_icon_2.png'),
  de_icon_3 = require('./../../../assets/imgs/de_icon_3.png'),
  de_icon_4 = require('./../../../assets/imgs/de_icon_4.png');
@Component({
  name: 'DashEvaluation'
})
export default class DashEvaluation extends Vue {
  private decContWidth = 0
  private deContentList: Array<any> = [
    {
      circle: de_circle_1, icon: de_icon_1, title: '备课', text: '每周进行备考，确保老师上课进度统一，上课内容一致，上课质量得到保证。'
    },
    {
      circle: de_circle_2, icon: de_icon_2, title: '串题', text: '组长带领大家进行串题，统一讲课思路，保证每个学生都能接受到相同的知识点和解题思路。'
    },
    {
      circle: de_circle_3, icon: de_icon_3, title: '赛课', text: '不定期举行赛课，即使走上讲台也要时时检测老师水平，督促老师成长。'
    },
    {
      circle: de_circle_4, icon: de_icon_4, title: '考核', text: '开课前统一考核，检测老师的上课功底和备课水平，只有真正优秀的人才能走上讲台。'
    }
  ]

  beforeMount() {
    if (document.body.clientWidth <= 1280) {
      this.decContWidth = 1060
    } else {
      this.decContWidth = document.body.clientWidth * 1212 / 1920
    }
  }
}
